// apps/dashboard/src/api/utils/toast.ts
// Pure utility: emitToast(message, variant) dispatches a CustomEvent on document.
// FR-013: All toast dispatches in the refinement feature route through this function.
// Decouples toast producers from the ToastProvider implementation.

/**
 * Valid toast variant values.
 */
export type ToastVariant = "success" | "error" | "warning" | "info";

/**
 * Detail shape carried by the "capicua:toast" CustomEvent.
 */
export interface ToastDetail {
  message: string;
  variant: ToastVariant;
}

/**
 * Dispatches a `capicua:toast` CustomEvent on `document` with the given
 * message and variant. The ToastProvider listens for this event and renders
 * the toast.
 */
export function emitToast(message: string, variant: ToastVariant): void {
  document.dispatchEvent(
    new CustomEvent<ToastDetail>("capicua:toast", {
      detail: { message, variant },
    }),
  );
}
